<template>
  <div>
    <h2 class="a11y-hidden">검색하기</h2>
    <div class="tag-box">
      <button
        type="button"
        class="button button-series"
        @click.prevent="showSearchPopup('broadcast')"
      >
        시리즈
        <em class="tag-text">#장르 #채널 #방영정보</em>
      </button>
      <button
        type="button"
        class="button button-movie"
        @click.prevent="showSearchPopup('movie')"
      >
        영화
        <em class="tag-text">#장르 #국가 #개봉연도</em>
      </button>
    </div>
  </div>
</template>

<script>
  import { sendEventLogShowTagSearchPopup } from '@/common/utils/log.v2.send'

  export default {
    name: 'SearchTagBox',
    methods: {
      showSearchPopup(type) {
        sendEventLogShowTagSearchPopup({ type: type })
        this.$events.$emit('showSearchPopupTag', type)
      },
    },
  }
</script>
<style lang="scss" scoped>
  .tag-box {
    padding: 0 100px;
  }
</style>
